import withFaceHighlightsMutation from './withFaceHighlightsMutation';

export default withFaceHighlightsMutation;
